import { Phone, MessageSquare, Mail, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/business";

export const Contact = () => (
  <section id="contact" data-testid="contact-booking" className="section-pad bg-navy relative overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute inset-0 opacity-[0.06]"
      style={{
        background:
          "radial-gradient(circle at 20% 20%, #c9a227 0%, transparent 40%), radial-gradient(circle at 80% 80%, #c9a227 0%, transparent 40%)",
      }}
    />

    <div className="container-tn relative">
      <div className="max-w-3xl mx-auto text-center">
        <span className="font-serif uppercase tracking-[0.3em] text-xs sm:text-sm text-gold">
          Ready To Book
        </span>
        <span className="block h-px w-16 bg-gold my-6 mx-auto" />
        <h2 className="font-serif text-white uppercase text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
          Let&apos;s get it<br />notarized today.
        </h2>
        <p className="mt-5 text-white/75 text-base sm:text-lg leading-relaxed">
          Tap to call for the fastest response, or book your appointment online in under a minute.
          Available by appointment — days, evenings &amp; weekends.
        </p>
      </div>

      {/* Giant tap-to-call */}
      <a
        href={`tel:${BUSINESS.phoneHref}`}
        data-testid="contact-call-link"
        className="mt-12 mx-auto max-w-3xl block group rounded-lg border border-gold/60 bg-white/[0.04] hover:bg-white/[0.08] transition-[background-color,transform] duration-200 hover:-translate-y-0.5 px-6 sm:px-10 py-8 sm:py-10 text-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-navy"
      >
        <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 border border-gold/40 mb-4 group-hover:bg-gold/25 transition-colors">
          <Phone className="w-7 h-7 text-gold" strokeWidth={2} />
        </div>
        <p className="font-serif uppercase tracking-[0.3em] text-xs text-gold-soft mb-2">
          Call or Text
        </p>
        <p
          data-testid="contact-phone-display"
          className="font-serif text-white text-4xl sm:text-5xl lg:text-6xl font-bold tracking-[0.02em] leading-none"
        >
          {BUSINESS.phoneDisplay}
        </p>
        <p className="mt-4 text-white/70 text-sm sm:text-base">
          Andreas answers directly — most calls booked in under 5 minutes.
        </p>
      </a>

      {/* Book Now button */}
      <div className="mt-8 flex justify-center">
        <a
          href={BUSINESS.bookingUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-book-button"
          className="btn-gold !py-4 !px-10 !text-base sm:!text-lg w-full max-w-md justify-center"
        >
          <CalendarCheck className="w-5 h-5" /> Book Now
        </a>
      </div>

      {/* Secondary text/email links */}
      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-3xl mx-auto">
        <a
          href={BUSINESS.smsHref}
          data-testid="contact-sms-link"
          className="flex items-center justify-center gap-3 rounded-md border border-gold/40 bg-white/[0.02] hover:bg-white/[0.06] transition-colors px-5 py-4 text-white"
        >
          <MessageSquare className="w-5 h-5 text-gold" />
          <span className="font-sans font-semibold">Text {BUSINESS.phoneDisplay}</span>
        </a>
        <a
          href={`mailto:${BUSINESS.email}`}
          data-testid="contact-email-link"
          className="flex items-center justify-center gap-3 rounded-md border border-gold/40 bg-white/[0.02] hover:bg-white/[0.06] transition-colors px-5 py-4 text-white min-w-0"
        >
          <Mail className="w-5 h-5 text-gold shrink-0" />
          <span className="font-sans font-semibold truncate">{BUSINESS.email}</span>
        </a>
      </div>

      <p className="mt-10 text-center text-white/60 text-sm">
        Hours: by appointment — days, evenings &amp; weekends. Serving River Grove and the western &amp; northwest Chicago suburbs.
      </p>
    </div>
  </section>
);
